import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ethers } from 'ethers';
import { toast } from 'react-hot-toast';
import { useAccount } from 'wagmi';
import { Link } from 'react-router-dom';
import { joinTeam, leaveTeam } from '../../web3/SFM-TeamsUtils';
import SocialTooltip from '../../social-wallet/tooltip';
import SharedActions from '../../components/sharedActions';
import SupportTeam from './SupportTeam';
import ConfirmModal from '../modals/ConfirmModal';
//adding new campaign page
const TeamSingleView = ({
  item,
  callSaveSucceed,
  isMyTeam = false,
  hasTeam = false,
}) => {
  const { address } = useAccount();
  const [isButtonClicked, setIsButtonClicked] = React.useState(false);
  const [isShowConfirmModal, setIsShowConfirmModal] = React.useState(false);

  const requestJoinTeam = async () => {
    try {
      setIsButtonClicked(true);
      await joinTeam(parseInt(item.id))
        .then((e) => {
          console.log(e);

          item.requiresApproval
            ? toast.success(
                `you request to join ${item.name} team sent to team leader successfully`
              )
            : toast.success(`you joined ${item.name} team successfully`);
          setIsButtonClicked(false);
          callSaveSucceed();
        })
        .catch((err) => {
          if (err?.reason !== '' && err?.reason !== undefined) {
            let searchWord = 'execution reverted: ';
            if (err.reason.indexOf(searchWord) !== -1) {
              err.reason = err.reason.replace(searchWord, '');
            }
            toast.error(err.reason);
          } else {
            toast.error(err);
          }
          hasTeam && callSaveSucceed();
          setIsButtonClicked(false);
        });
    } catch (e) {
      if (e?.code == 'ACTION_REJECTED') {
        toast.error('You have canceled the transaction');
      } else if (e.error.data.code == 3) {
        toast.error(
          'You have already submitted a join request to another team. Please wait until the request is resolved'
        );
      } else {
        toast.error(e.message);
      }
      hasTeam && callSaveSucceed();
      setIsButtonClicked(false);
    }
  };

  const leaveYourTeam = async () => {
    try {
      setIsButtonClicked(true);
      await leaveTeam().then((e) => {
        console.log(e);

        toast.success(`you leaved ${item.name} team successfully`);
        setIsButtonClicked(false);
        callSaveSucceed();
      });
    } catch (e) {
      setIsButtonClicked(false);
      if (e?.code == 'ACTION_REJECTED') {
        toast.error('You have canceled the transaction');
      } else {
        toast.error(e.message);
      }
    }
  };

  const handleChangeTeam = async () => {
    setIsShowConfirmModal(false);
    setIsButtonClicked(true);
    if (hasTeam) {
      try {
        await leaveTeam()
          .then(async (e) => {
            await requestJoinTeam(item.id.toString());
          })
          .catch((e) => {
            if (e?.code == 'ACTION_REJECTED') {
              toast.error('You have canceled the transaction');
            } else {
              toast.error(e.message);
            }
            setIsButtonClicked(false);
          });
      } catch (e) {
        if (e?.code == 'ACTION_REJECTED') {
          toast.error('You have canceled the transaction');
        } else {
          toast.error(e.message);
        }
        setIsButtonClicked(false);
      }
    } else {
      await requestJoinTeam(item.id.toString());
    }
  };

  return (
    <>
      <div className="content">
        <div className="latest-games-items mb-30">
          <div className="latest-games-thumb figure-image-container">
            <a>
              <img
                className="figure-image"
                src={
                  address == item.leader ? item.leaderImage : item.memberImage
                }
                alt=""
              />
            </a>
            <div className="content-overlay"></div>
          </div>
          <div className="content-details fadeIn-bottom">
            <p className="content-text">{item.description}</p>
          </div>
          <div className="latest-games-content">
            <div className="lg-tag">
              <a>{item.rules}</a>
            </div>
            <Row>
              <Col>
                <h4>
                  <Link to={`/single-team?id=${item.id.toString()}`}>
                    {item.name}
                  </Link>
                </h4>
                <br />
                <SocialTooltip title={'Team Total Balance'}>
                  <span>Balance: {ethers.utils.formatEther(item.balance)}</span>
                </SocialTooltip>
              </Col>
              <Col className="float-right col-auto text-right">
                <SharedActions
                  openseaLink={`${process.env.REACT_APP_OPENSEA_LINK}/${
                    process.env.REACT_APP_SFM_OPENSEA_NETWORK
                  }/${item.contractAddress}/${parseInt(item.tokenId)}`}
                  tweetTitle={`Please join the ${item.name} team`}
                  tweetLink={`${
                    window.location.origin
                  }/#/single-team?id=${parseInt(item.id)}`}
                  className="float-right"
                />
                <SupportTeam teamId={parseInt(item.id)} teamName={item.name} />
              </Col>
            </Row>
            <div>
              Joining fees :{' '}
              <span>{ethers.utils.formatEther(item.joiningFee)}</span>{' '}
              {address !== item.leader && !item.isLeader && (
                <>
                  <a
                    onClick={() => {
                      isMyTeam ? leaveYourTeam() : setIsShowConfirmModal(true);
                    }}
                    className={`btn btn-style-two float-right ${
                      isMyTeam && 'btn-red'
                    }`}
                  >
                    {isButtonClicked ? (
                      <div className="lds-dual-ring"></div>
                    ) : isMyTeam ? (
                      'Leave'
                    ) : (
                      'Join'
                    )}
                  </a>
                  <p className="mt-2 text-mutes float-right">
                    {item.requiresApproval &&
                      'Joining Team Require Leader Approve'}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>{' '}
      {isShowConfirmModal && (
        <ConfirmModal
          show={isShowConfirmModal}
          handleCloseParent={() => {
            setIsShowConfirmModal(false);
          }}
          msg={
            hasTeam
              ? 'Are you sure you want to change your team?'
              : 'Are you Sure you want to join this team?'
          }
          subText={hasTeam ? 'You will leave the current team.' : ''}
          handleConfirm={() => handleChangeTeam()}
        />
      )}
    </>
  );
};

export default TeamSingleView;
